import { numericOnly } from '@/directives/numericOnly'
import DocumentsApi from '../api'
import numberFormat from '@/filters/numberFormat'

export default {
  data () {
    return {
      saving: false
    }
  },
  directives: {
    numericOnly
  },
  filters: {
    numberFormat
  },
  computed: {
    commonQty () {
      let commonQty = 0
      this.document.records.forEach((record, i, arr) => {
        commonQty += record.kolichestvo
      })
      return commonQty
    }
  },
  methods: {
    async deleteDocument () {
      let response = await DocumentsApi.deleteDocument({ name: this.name, docId: this.id })
      if (response.success) {
        this.$router.go(-1)
      } else {
        console.log(response.error)
      }
    },
    async saveDocument (forceSave = 0) {
      this.saving = true
      let response = await DocumentsApi.saveDocument({
        id: this.id,
        name: this.name,
        modified_on: this.document.modified_on,
        records: this.getRecordsForSave(),
        comment: this.document.comment,
        force_save: forceSave
      })
      if (response.success) {
        response.document.summa = parseFloat(response.document.summa)
        this.document = response.document
        this.messageType = 'success'
        this.messageText = 'Документ сохранен'
        this.messageDisplay = true
      } else {
        if (response.is_prompt && response.message) {
          this.$refs.messageModal.open(response.message, true)
        } else if (response.message) {
          this.messageType = 'error'
          this.messageText = response.message
          this.messageDisplay = true
        }
        console.log(response.error)
      }
      this.saving = false
    },
    forceSaveDocument () {
      this.saveDocument(1)
    }
  }
}
